/**
 * This allows you to control how descriptive the measurement will be.
 *
 * The total amount of measurements will differ depending on what type of product it is displayed.
 */
var ProductDescriptionProductMeasureEnum;
(function (ProductDescriptionProductMeasureEnum) {
    /**
     * Don't display any measurements for the product.
     */
    ProductDescriptionProductMeasureEnum["none"] = "none";
    /**
     * Displays a minimal text describing the measurment for the product.
     *
     * The text comes from the "measureReference" available in the products content.
     */
    ProductDescriptionProductMeasureEnum["short"] = "short";
    /**
     * Displays a descriptive comma separated text for the product.
     *
     * Measurements for the product comes from the "measure" array available in the products content.
     */
    ProductDescriptionProductMeasureEnum["long"] = "long";
    /**
     * An array of objects containg the measurement and measurement type.
     *
     * Measurements for the product comes from the "measure" array on the displayed product.
     *
     * Should only be used if the intention is to control how the data will be displayed.
     */
    ProductDescriptionProductMeasureEnum["array"] = "array";
})(ProductDescriptionProductMeasureEnum || (ProductDescriptionProductMeasureEnum = {}));
export default ProductDescriptionProductMeasureEnum;
//# sourceMappingURL=ProductDescriptionProductMeasureEnum.js.map